import { ISelectValue } from '@/shared/types/select';

export const fonts: ISelectValue[] = [
  {
    id: 'Montserrat Variable',
    name: 'Montserrat'
  },
  {
    id: 'Oswald Variable',
    name: 'Oswald'
  },
  {
    id: 'Playfair Display Variable',
    name: 'Playfair Display'
  },
  {
    id: 'Roboto Slab Variable',
    name: 'Roboto Slab'
  },
  {
    id: 'PT Mono',
    name: 'PT Mono'
  }
];

export type TFonts = typeof fonts;

export const placements: ISelectValue[] = [
  {
    id: 'bottom',
    name: 'Внизу экрана'
  },
  {
    id: 'top',
    name: 'Вверху экрана'
  },
  {
    id: 'center',
    name: 'Посередине'
  }
];

export type TPlacements = typeof placements;

export const DEFAULT_SETTINGS = {
  font_size: 25,
  line_height_factor: 1.2
};
